module.exports = __webpack_public_path__ + "img/info.bb0d54a2.svg";